import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "src/components/ui/Card";
import { Badge } from "src/components/ui/Badge";
import { Star, Clock, MapPin, BookOpen } from "lucide-react";
import { Tutor } from "src/services/tutorsService";
import { getTutorEducation } from "src/components/tutor/Search";
import {
  getTutorName,
  getTutorPhoto,
  getTutorSpecialties,
  getTutorExperience,
  getTutorLocation,
} from "../utils/tutorHelpers";

interface TutorInfoCardProps {
  tutor: Tutor;
}

const TutorInfoCard: React.FC<TutorInfoCardProps> = ({ tutor }) => {
  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-lg">Tutor Information</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex items-center mb-4">
          <img
            src={getTutorPhoto(tutor)}
            alt={getTutorName(tutor)}
            className="w-16 h-16 rounded-full object-cover mr-4"
          />
          <div>
            <h3 className="font-medium">{getTutorName(tutor)}</h3>
            <div className="flex items-center mt-1">
              <Star className="h-4 w-4 text-yellow-400 fill-yellow-400" />
              <span className="ml-1 text-sm font-medium">
                {tutor.rating ? tutor.rating.toFixed(1) : "No rating yet"}
              </span>
            </div>
          </div>
        </div>

        <div className="space-y-2 mb-4">
          <div className="flex items-center text-sm">
            <Clock className="h-4 w-4 mr-2 text-gray-500" />
            <span className="text-gray-700">{getTutorExperience(tutor)}</span>
          </div>
          <div className="flex items-center text-sm">
            <MapPin className="h-4 w-4 mr-2 text-gray-500" />
            <span className="text-gray-700">{getTutorLocation(tutor)}</span>
          </div>
          <div className="flex items-center text-sm">
            <BookOpen className="h-4 w-4 mr-2 text-gray-500" />
            <span className="text-gray-700">{getTutorEducation(tutor)}</span>
          </div>
        </div>

        <div className="mb-4">
          <h4 className="text-sm font-medium mb-2">Specialties:</h4>
          <div className="flex flex-wrap gap-2">
            {getTutorSpecialties(tutor).map((specialty: string) => (
              <Badge
                key={specialty}
                variant="secondary"
                className="bg-gray-100 text-gray-700"
              >
                {specialty}
              </Badge>
            ))}
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default TutorInfoCard;